import { ContextMenu, ContextMenuItem, DeleteModelWithUsagesDialog, Id, useModelUsage } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { contactFilterService } from "../shared/api/contactFilterService";

interface Props {
	filterId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const ContactFilterContextMenu: FC<Props> = ({ filterId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();
	const showUsageAction = useCallback(
		() => contactFilterService.showUsage(filterId).then((r) => r.data.data),
		[filterId],
	);
	const { handleUsage, ...usageModalProps } = useModelUsage(showUsageAction);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				<ContextMenuItem label={t("Edit")} title={t("Edit")} action={handleEdit} icon="edit" shortcut="primary" />
				<ContextMenuItem action={handleUsage} title={t("Delete")} label={t("Delete")} icon="delete" />
			</ContextMenu>
			<DeleteModelWithUsagesDialog
				modelName={t("Contact filter")}
				confirmationBody={t("Are you sure you want to delete this contact filter?")}
				deleteAction={handleDelete}
				{...usageModalProps}
			/>
		</>
	);
};
